/**
 * Caminhos canônicos da aplicação.
 *
 * **A marca é o hostname.** O middleware resolve o tenant pelo header
 * `x-caller-url`, exatamente como no `link-venda-direta` e no `webpresence`:
 * não existe domínio compartilhado, prefixo `/{marca}` na URL nem descoberta
 * da marca pela linha digitada. Por isso cada página de
 * `src/defaults/mainpage.json` é registrada UMA única vez, no seu caminho
 * canônico, e não há mais lista de segmentos reservados.
 *
 * `legacy` é **contrato externo** do produto Link de Venda Direta
 * (`/renova_plano?t={R|A|C}&id={id}`): a string nunca muda, e a página
 * continua respondendo mesmo quando a identidade da marca falha ou está
 * suspensa no ERP (ver `src/layouts/index.tsx`).
 */
export const ROUTES = {
  home: '/',
  plans: '/planos-lista',
  card: '/cartao-credito',
  legacy: '/renova_plano',
  healthcheck: '/healthcheck',
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];
